import { render, staticRenderFns } from "./ZhanhuiCgtcBlock.vue?vue&type=template&id=077dca80&scoped=true"
import script from "./ZhanhuiCgtcBlock.vue?vue&type=script&lang=js"
export * from "./ZhanhuiCgtcBlock.vue?vue&type=script&lang=js"
import style0 from "./ZhanhuiCgtcBlock.vue?vue&type=style&index=0&id=077dca80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077dca80",
  null
  
)

export default component.exports